import React from "react";
import { getSlot } from "@/lib/brandAssets";

/**
 * Layered kinetic hex / dot backdrop used in hero sections. Pure CSS + a
 * floating hex group asset. Three layers respond to `--mx/--my` set by
 * the parent `useMouseParallax` container.
 */
export default function KineticHexBackdrop() {
  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none" aria-hidden="true">
      {/* dotted grid */}
      <div className="absolute inset-0 kb-kinetic-hex opacity-70" />

      {/* soft purple aura */}
      <div
        className="absolute -top-32 -left-20 w-[520px] h-[520px] rounded-full kb-parallax-strong"
        style={{ background: "radial-gradient(closest-side, rgba(122,68,252,0.22), transparent 70%)" }}
      />
      <div
        className="absolute -bottom-40 right-[-120px] w-[600px] h-[600px] rounded-full kb-parallax"
        style={{ background: "radial-gradient(closest-side, rgba(244,240,255,1), transparent 75%)" }}
      />

      {/* floating hex group asset */}
      <img
        src={getSlot("decor.hex.group")}
        alt=""
        className="absolute right-[6%] top-[12%] w-[260px] opacity-60 kb-parallax-strong animate-kb-drift hidden md:block"
        draggable="false"
      />
      <img
        src={getSlot("decor.k.purple")}
        alt=""
        className="absolute left-[3%] bottom-[10%] w-[80px] opacity-40 kb-parallax animate-kb-float hidden md:block"
        draggable="false"
      />
    </div>
  );
}
